const positions = [
  {
    company: 'TheBeastShop',
    position: 'Lead Android Developer',
    link: 'https://thebeastshop.com',
    daterange: 'October 2020 - Present',
    points: [
      'Deployed quantitative strategies to predict the value of fine art in various pricing contexts.',
      'Built production, on-line, end-to-end optimized machine learning pipelines with Pandas, Numpy, Scikit, Tensorflow, Dagster, Postgres, etc. on GCP with Kubernetes.',
      'Designed micro-service architecture around: data collection, data integrity, feature engineering, research, strategy, backtesting, deployment, and reporting.',
      'YC Alumn. Worked on everything. Built a 16-person team. Operated company for 6+ years.',
    ],
  },
  {
    company: 'FrontEnd e-Commercial',
    position: 'Android Developer',
    link: 'https://www.2298.com/',
    daterange: 'April 2018 - September 2020',
    points: [
      'Founded a micro-vc fund to throw token amounts of money at problems I find interesting.',
      'Created the InstaSafe. Fast, automated investment docs for YC companies.',
    ],
  },
  {
    company: 'Hikvision',
    position: 'Product Engineer',
    link: 'https://www.hikvision.com',
    daterange: 'September 2017 - April 2018',
    points: [
      'Trained a model for the Brazilian Coffee Scenes Dataset with better than state of the art accuracy.',
      'Collected training sets on the ground in Uganda. Built dashboards to visualize work of surveyors using Flask, React, and D3.',
      'Performed supporting analysis to ensure data integrity using Pandas, t-SNE, SVM’s, and other techniques.',
    ],
  },
  {
    company: 'Hella',
    position: 'Product Failure Analysis',
    link: 'https://www.hella.com',
    daterange: 'February 2016 - September 2017',
    points: [
      'Worked in Addis Ababa for the Ethiopian Ministry of Health and built data visualization tools in React and Flask.',
      'Ingested multiple databases with different alphabets, calendars, and without official spellings of geographic locations.',
    ],
  },
  {
    company: 'Valeo',
    position: 'Project Quality Engineer',
    link: 'https://www.valeo.com/en/',
    daterange: 'July 2011 - January 2016',
    points: [
      'Developed end to end machine learning pipeline to train visual classifiers from keywords using Node.JS, Express, Keystone, MongoDB, AWS, S3, Caffe, and other technologies.',
      'Received Series A term sheets for 20M+ valuations.',
    ],
  },
];

export default positions;
